import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import { Button } from '../../Button';
import { Description } from '../../Description';
import { Key } from '../../Key';
import { Text } from '../../Text';
import styles from './AccordionWizard.Step.scss';
export var AccordionWizardStepDefaultProps = {
  isActive: false,
  isFirstStep: false,
  isComplete: false,
  isLastStep: false,
  buttonDisabled: true,
  backButtonText: 'Back',
  index: 0,
  nextButtonText: 'Next',
  submitButtonText: 'Create'
};
export var AccordionWizardStep = function AccordionWizardStep(_ref) {
  var _classnames;

  var buttonDisabled = _ref.buttonDisabled,
      children = _ref.children,
      dataTest = _ref.dataTest,
      keyLabel = _ref.keyLabel,
      label = _ref.label,
      isFirstStep = _ref.isFirstStep,
      isComplete = _ref.isComplete,
      isActive = _ref.isActive,
      isLastStep = _ref.isLastStep,
      backButtonText = _ref.backButtonText,
      nextButtonText = _ref.nextButtonText,
      submitButtonText = _ref.submitButtonText,
      summary = _ref.summary,
      onBack = _ref.onBack,
      onNext = _ref.onNext,
      onSubmit = _ref.onSubmit;
  var stepStyles = classnames(styles.step, (_classnames = {}, _defineProperty(_classnames, styles.isActive, isActive), _defineProperty(_classnames, styles.isLastStep, isLastStep), _classnames));
  return React.createElement("li", {
    className: stepStyles,
    role: "listitem",
    "data-test": dataTest
  }, React.createElement("div", {
    className: styles.block
  }, React.createElement("div", {
    className: styles.top
  }, React.createElement(Key, {
    complete: isComplete,
    text: keyLabel,
    variant: isActive ? 'active' : 'inactive'
  }), React.createElement("div", {
    className: styles.info
  }, isActive ? React.createElement("div", null, React.createElement(Text, null, label)) : React.createElement("div", null, React.createElement(Text, {
    color: "light"
  }, label)), summary && !isActive && (typeof summary === 'string' ? React.createElement(Description, null, summary) : summary))), isActive && React.createElement(React.Fragment, null, React.createElement("div", {
    className: styles.content
  }, children), React.createElement("div", {
    className: styles.buttons
  }, !isFirstStep && React.createElement(Button, {
    variant: "neutral",
    dataTest: "back-button",
    onClick: onBack
  }, backButtonText), isLastStep ? React.createElement(Button, {
    variant: "primary",
    dataTest: "submit-button",
    disabled: buttonDisabled,
    onClick: onSubmit
  }, submitButtonText) : React.createElement(Button, {
    variant: "primary",
    dataTest: "next-button",
    disabled: buttonDisabled,
    onClick: onNext
  }, nextButtonText)))));
};
AccordionWizardStep.defaultProps = AccordionWizardStepDefaultProps;